export default __webpack_public_path__ + "static/media/ICICI-Bank.d885a0c9.webp";